/* Outfit Match owns only its form, quota and result references. Image storage,
   mockup placement, preview protection, consent and checkout remain shared. */
(function () {
  'use strict';
  const KEY = 'robopixel_outfit_matches_v1', TTL = 72 * 60 * 60 * 1000;
  const $ = s => document.querySelector(s);
  const all = s => Array.from(document.querySelectorAll(s));
  // Trikot-Match: the football page opens this tool with ?match=jersey. Same
  // quota, storage and checkout; the server picks the crest prompt and model.
  const jersey = () => new URLSearchParams(window.location.search).get('match') === 'jersey';
  const copy = key => { const o = window.CUSTOMIZER_I18N.outfit || {}; return (jersey() && o['jersey_' + key]) || o[key] || ''; };
  const studio = key => (window.CUSTOMIZER_I18N.studio || {})[key] || '';
  const vipCode = () => { try { return sessionStorage.getItem('robopixel_vip_code') || ''; } catch { return ''; } };
  let photo = null, detail = null, busy = false, reading = 0, quota = null, quotaFailed = false;
  let widget = null, cancelSecurity = null, epoch = 0, pendingResult = null;
  // Server-owned prompt choice, 0-3: one of four server prompts per try.
  // Steps on each generation for the same outfit; a new outfit restarts at 0.
  let promptTurn = 0;
  let history = [], sequences = { photo: 0, detail: 0 };
  const assets = new Map(); // Retain active/undo print handles when history is cleared.
  const previews = { photo: null, detail: null };
  const modal = () => $('#outfit-match-modal');
  const status = text => { $('#outfit-status').textContent = text; const stage = $('[data-outfit-stage]'); if (stage) stage.textContent = text; };
  function error(text) { const node = $('#outfit-error'); node.textContent = text; node.hidden = !text; }
  // Wait estimate shown while a match is created. A guide, not a promise: it
  // races to zero when the match arrives early and holds at "almost there"
  // when the match is late. Deadline-based, so a background tab stays right.
  const WAIT_SECONDS = 30, WAIT_LINE_MS = 5000, TURBO_MS = 700, DONE_MS = 500;
  let waitRun = 0, waitTimer = null, waitEnds = 0, waitLinesFrom = 0;
  const calm = () => !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
  const write = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  const leaving = event => { event.preventDefault(); event.returnValue = ''; };
  function paintWait(seconds, phase, filled) {
    const box = $('[data-outfit-processing]');
    if (!box) return;
    box.setAttribute('data-wait', phase);
    write($('[data-outfit-countdown-number]'), String(seconds));
    write($('[data-outfit-countdown-label]'), copy('countdown_' + phase));
    const bar = $('[data-outfit-progress]');
    if (bar) bar.style.width = filled + '%';
  }
  function tickWait() {
    const left = Math.max(0, waitEnds - Date.now());
    // The bar never looks finished while the match is still being created.
    paintWait(Math.ceil(left / 1000), left ? 'running' : 'late', Math.min(94, 100 - left / (WAIT_SECONDS * 10)));
    if (!waitLinesFrom) return;
    const lines = ['working', 'working_2', 'working_3'].map(copy).filter(Boolean);
    if (lines.length) write($('[data-outfit-stage]'), lines[Math.floor((Date.now() - waitLinesFrom) / WAIT_LINE_MS) % lines.length]);
  }
  function startWait() {
    stopWait();
    const box = $('[data-outfit-countdown]');
    if (!box) return;
    waitEnds = Date.now() + WAIT_SECONDS * 1000; box.hidden = false;
    tickWait(); waitTimer = setInterval(tickWait, 250);
    // Leaving mid-generation can lose the try; the browser asks first.
    window.addEventListener?.('beforeunload', leaving);
  }
  function stopWait() {
    waitRun++; clearInterval(waitTimer); waitTimer = null; waitLinesFrom = 0;
    window.removeEventListener?.('beforeunload', leaving);
    const box = $('[data-outfit-countdown]');
    if (box) box.hidden = true;
    $('[data-outfit-processing]')?.removeAttribute('data-wait');
    const bar = $('[data-outfit-progress]');
    if (bar) bar.style.width = '';
  }
  // The match arrived: run the remaining seconds down fast instead of waiting them out.
  async function turboWait() {
    const run = waitRun, from = Math.ceil(Math.max(0, waitEnds - Date.now()) / 1000), started = Date.now();
    clearInterval(waitTimer); waitTimer = null; waitLinesFrom = 0;
    if (!from || calm()) return;
    for (let t = 0; t < 1 && run === waitRun;) {
      t = Math.min(1, (Date.now() - started) / TURBO_MS);
      paintWait(Math.round(from * (1 - t) * (1 - t)), 'turbo', 100);
      if (t < 1) await pause(40);
    }
  }
  async function finishWait() {
    paintWait(0, 'done', 100); write($('[data-outfit-stage]'), copy('ready'));
    await pause(calm() ? 0 : DONE_MS);
  }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(history)); } catch { /* Current tab still works. */ } }
  function validResult(item) {
    if (!item || !Number.isFinite(item.createdAt) || item.createdAt > Date.now() || item.createdAt + TTL <= Date.now() || !/^[a-f0-9]{64}$/.test(item.assetId || '')) return false;
    try {
      const u = new URL(item.url);
      return u.protocol === 'https:' && u.hostname === 'robopixel-designs-eu-121505946416-eu-central-1-an.s3.eu-central-1.amazonaws.com' &&
        /^\/cart-full-images\/[a-f0-9-]+\.(jpg|jpeg|png|webp)$/i.test(u.pathname) && !u.search && !u.hash;
    } catch { return false; }
  }
  // The outfit photo behind a result: the same 72-hour upload the generator
  // read, linked to the purchased line so the print can be checked against it.
  function validReference(value) {
    try {
      const u = new URL(value);
      return u.protocol === 'https:' && u.hostname === 'robopixel-designs-eu-121505946416-eu-central-1-an.s3.eu-central-1.amazonaws.com' &&
        /^\/transform-originals\/[a-f0-9-]+\.(jpg|jpeg|png|webp)$/i.test(u.pathname) && !u.search && !u.hash;
    } catch { return false; }
  }
  function prune() { history = history.filter(validResult); persist(); renderHistory(); }
  function renderHistory() {
    refreshHistoryVisibility();
    all('[data-outfit-strip]').forEach(strip => {
      strip.replaceChildren();
      history.forEach((item, i) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'cz-outfit-thumb';
        button.setAttribute('aria-label', copy('use_match').replace('{number}', i + 1));
        button.setAttribute('aria-pressed', String(selectedDesignUrl === item.url));
        const img = document.createElement('img'); img.src = rpDisplayUrl(item.url); img.alt = ''; button.append(img);
        rpShieldPreviewSurface(img, () => rpHasCleanTwin(item.url));
        button.addEventListener('click', () => apply(item)); strip.append(button);
      });
    });
  }
  function refreshHistoryVisibility() {
    const relevant = window.RoboPixelJourney?.method?.() === 'outfit' && $('#step-customizer')?.dataset.journey !== 'review';
    all('[data-outfit-results]').forEach(n => { n.hidden = !history.length || !relevant; });
  }
  const freeLimitReached = () => !quotaFailed && quota?.tier === 'free' && (quota.remaining === 0 || quota.allowed === false) &&
    ['device_allowance_used', 'network_allowance_used', 'daily_capacity_reached'].includes(quota.reason);
  const freeUnavailable = () => quotaFailed || (quota?.tier === 'free' && quota.allowed === false && !freeLimitReached());
  const showFreeLimit = () => !busy && !pendingResult && (freeLimitReached() || freeUnavailable());
  const freeLimitCopy = () => copy(quota?.reason === 'device_allowance_used' ? 'used' : 'free_limit');
  function showQuota() {
    let label = copy(quotaFailed ? 'unavailable' : 'checking');
    if (quota && !quotaFailed) {
      label = quota.remaining > 0 ? copy('remaining').replace('{count}', quota.remaining) : copy('used');
      if (quota.tier === 'pixelback') label = studio('paid_remaining').replace('{count}', quota.remaining);
      if (freeLimitReached()) label = freeLimitCopy();
      else if (quota.remaining === 0 && quota.reason && quota.reason !== 'device_allowance_used') label = copy('unavailable');
    }
    all('[data-outfit-count]').forEach(n => { n.textContent = label; n.hidden = showFreeLimit(); });
    const limit = $('[data-outfit-limit]');
    if (limit) {
      limit.hidden = !showFreeLimit();
      if (!limit.hidden) $('[data-outfit-limit-copy]').textContent = freeLimitReached() ? freeLimitCopy() : copy('unavailable');
    }
    const purchase = $('.cz-outfit-limit [data-pixelback-checkout]');
    if (purchase) purchase.hidden = quotaFailed && !!vipCode();
    const recheck = $('[data-outfit-recheck]');
    if (recheck) recheck.hidden = !showFreeLimit();
    $('[data-outfit-submit]').hidden = showFreeLimit();
    $('[data-outfit-consent]').hidden = showFreeLimit();
    const upgrade = $('[data-outfit-upgrade]');
    if (upgrade) upgrade.hidden = showFreeLimit() || quota?.tier === 'pixelback' || !history.length;
    if (typeof renderVIPStatusBar === 'function') renderVIPStatusBar();
  }
  async function quotaRequest(action, grant) {
    const requestCode = vipCode();
    const response = await fetchWithTimeout(UPLINK_WORKER + '/generations/' + action, {
      method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'outfit', vipCode: requestCode, fingerprint: await getDeviceFingerprint(), deviceToken: getStoredDeviceToken(), ...(grant ? { grant } : {}) })
    }, 20000);
    const data = await readJsonWithTimeout(response, 10000);
    if (requestCode !== vipCode()) {
      if (action === 'check') return null; // A late free response cannot overwrite paid recovery.
      throw new Error(copy('unavailable'));
    }
    // Older Uplink versions normalize unknown engines to Portrait. Never let
    // a partially deployed feature consume a customer's portrait allowance.
    if (response.ok && (data.type !== 'outfit' || data.maxGenerations !== (data.tier === 'pixelback' ? 10 : 4))) throw new Error(copy('unavailable'));
    if (data.deviceToken) storeDeviceToken(data.deviceToken);
    if (Number.isInteger(data.remaining)) {
      quotaFailed = false;
      // The successful fourth free increment has no reason field, but it has
      // consumed this device's last try. Show the purchase path immediately.
      quota = { ...data, reason: data.reason || (data.tier === 'free' && data.remaining === 0 && response.ok && action === 'increment' ? 'device_allowance_used' : undefined) };
      showQuota();
    }
    if (!response.ok) throw Object.assign(new Error(copy('unavailable')), { code: data.error });
    return data;
  }
  function controls() {
    all('[data-outfit-picker], [data-outfit-remove-detail]').forEach(n => { n.disabled = busy || reading > 0; });
    const button = $('[data-outfit-submit]');
    button.disabled = busy || reading > 0;
    button.textContent = busy ? copy('working') : pendingResult ? copy('see_match') : copy('create');
    $('[data-outfit-inputs]').setAttribute('aria-busy', String(busy || reading > 0));
    $('[data-outfit-inputs]').hidden = busy;
    const processing = $('[data-outfit-processing]');
    if (processing) processing.hidden = !busy;
    $('#outfit-status').hidden = busy;
  }
  function close() {
    sequences.photo++; sequences.detail++;
    epoch++; modal().hidden = true;
    if (cancelSecurity) cancelSecurity();
  }
  // Rewrites the window's fixed wording for the current mode (Liquid renders Outfit Match).
  function applyMode() {
    modal().dataset.mode = jersey() ? 'jersey' : 'outfit';
    // Keys without a script copy (the print tips) keep the wording Liquid rendered.
    all('[data-outfit-text]').forEach(n => { const text = copy(n.dataset.outfitText); if (text) n.textContent = text; });
    all('[data-outfit-alt]').forEach(n => { const text = copy(n.dataset.outfitAlt); if (text) n.alt = text; });
    $('[data-outfit-photo-label]').textContent = copy(photo ? 'change_photo' : 'add_photo');
    $('[data-outfit-detail-label]').textContent = copy(detail ? 'change_detail' : 'add_detail');
  }
  async function open() {
    if (!modal()) return;
    window.RoboPixelJourney?.setMethod?.('outfit');
    applyMode();
    selectPhotoConsentMode('ai');
    modal().hidden = false; error(''); prune(); controls();
    if (busy) { status(copy('working')); return; }
    status(pendingResult ? copy('ready') : '');
    quotaFailed = false; quota = null; showQuota();
    try { await quotaRequest('check'); } catch (failure) {
      quotaFailed = true; quota = null; showQuota();
      console.warn('[Outfit Match] allowance check failed', failure.code || failure.name || 'Error');
    }
  }
  async function readPhoto(file, kind) {
    if (!file || busy || reading > 0) return;
    const sequence = ++sequences[kind]; reading++; controls(); error('');
    try {
      if (file.size > 12 * 1024 * 1024 || !(/^(image\/(jpeg|png|webp|heic|heif))$/.test(file.type) || /\.(heic|heif)$/i.test(file.name))) throw new Error('file');
      const decodedFile = await ensureJpeg(file);
      const url = URL.createObjectURL(decodedFile);
      let cropped;
      try {
        const image = await loadImage(url);
        if (!image.naturalWidth || image.naturalWidth * image.naturalHeight > 50000000) throw new Error('file');
        if (sequence !== sequences[kind]) return;
        // Crop the original resolution before resizing the selected area.
        cropped = await new Promise((resolve, reject) => {
          openCropModal(url, null, {
            parent: modal(),
            isCurrent: () => sequence === sequences[kind],
            canvasOptions: { maxWidth: 1600, maxHeight: 1600, fillColor: '#fff' },
            onComplete: (result, failure) => failure ? reject(failure) : resolve(result)
          }).catch(reject);
        });
      } finally { URL.revokeObjectURL(url); }
      if (!cropped || sequence !== sequences[kind]) return;
      const blob = await new Promise(resolve => cropped.toBlob(resolve, 'image/jpeg', .92));
      if (!blob) throw new Error('file');
      if (sequence !== sequences[kind]) return;
      // Re-encoding strips photo metadata; references stay local until Create.
      // The close-up is available from the start; keep it when the first main
      // photo is added, but clear it when replacing an existing outfit.
      if (kind === 'photo') { if (photo) removeDetail(); photo = blob; promptTurn = 0; } else detail = blob;
      if (previews[kind]) URL.revokeObjectURL(previews[kind]);
      previews[kind] = URL.createObjectURL(blob);
      const preview = $('[data-outfit-' + kind + '-preview]'); preview.src = previews[kind]; preview.hidden = false;
      $('[data-outfit-' + kind + '-label]').textContent = copy(kind === 'photo' ? 'change_photo' : 'change_detail');
      if (kind === 'photo') $('[data-outfit-icon]').setAttribute('hidden', '');
      else $('[data-outfit-remove-detail]').hidden = false;
      pendingResult = null;
    } catch { error(copy('file_error')); }
    finally { reading--; controls(); }
  }
  function removeDetail() {
    sequences.detail++; detail = null;
    if (previews.detail) URL.revokeObjectURL(previews.detail);
    previews.detail = null;
    const preview = $('[data-outfit-detail-preview]'); preview.hidden = true; preview.removeAttribute('src');
    $('#outfit-detail').value = ''; $('[data-outfit-remove-detail]').hidden = true;
    $('[data-outfit-detail-label]').textContent = copy('add_detail');
  }
  async function verifyHuman() {
    status(copy('security'));
    await window.loadCustomizerTurnstile();
    if (modal().hidden) throw new Error('cancelled');
    if (widget !== null) window.turnstile.remove(widget);
    return new Promise((resolve, reject) => {
      let finished = false;
      const finish = (token, reason) => { if (finished) return; finished = true; clearTimeout(timer); cancelSecurity = null; token ? resolve(token) : reject(new Error(reason || 'security')); };
      const timer = setTimeout(() => finish(null, 'security'), 45000);
      cancelSecurity = () => finish(null, 'cancelled');
      try {
        widget = window.turnstile.render('#outfit-turnstile', {
          sitekey: PQ_TURNSTILE_SITEKEY, action: 'outfit_generate', appearance: 'interaction-only', size: 'compact',
          callback: token => finish(token), 'error-callback': () => finish(), 'expired-callback': () => finish(), 'timeout-callback': () => finish()
        });
      } catch { finish(); }
    });
  }
  function apply(item) {
    if (!validResult(item)) { prune(); error(copy('expired')); return; }
    window.RoboPixelJourney?.remember();
    applyPromptImageToCanvas(item.url, item.url);
    // 'ai' preserves the shared storage/cart contracts; the line item records
    // Outfit Match separately, with the opaque full-resolution asset handle.
    pendingResult = null; close(); renderHistory();
    window.RoboPixelJourney?.edit();
    window.RoboPixelJourney?.announce(copy('ready'));
    $('#transform-retry-container')?.classList.add('hidden');
  }
  async function create() {
    if (busy || reading) return;
    if (pendingResult) { apply(pendingResult); return; }
    error('');
    if (!photo) { error(copy('need_photo')); $('[data-outfit-picker="photo"]').focus(); return; }
    if (!requirePhotoConsent('ai', 'outfit-photo-consent')) return;
    busy = true; controls(); startWait(); const attempt = epoch;
    let grant = null, received = false, stage = 'eligibility';
    const watching = () => attempt === epoch && !modal().hidden;
    const stillAllowed = () => watching() && requirePhotoConsent('ai', 'outfit-photo-consent', false);
    try {
      const checked = await quotaRequest('check');
      if (checked.allowed === false || checked.remaining < 1) { if (!freeLimitReached()) error(copy('unavailable')); return; }
      if (!stillAllowed()) return;
      stage = 'security';
      const token = await verifyHuman();
      if (!stillAllowed()) return;
      status(copy('uploading'));
      stage = 'upload';
      const photoUrl = await uploadToS3(photo, 'transform-originals');
      if (!photoUrl) throw new Error('upload');
      if (!stillAllowed()) return;
      const detailUrl = detail ? await uploadToS3(detail, 'transform-originals') : null;
      if (detail && !detailUrl) throw new Error('upload');
      if (!stillAllowed()) return;
      stage = 'allowance';
      const counted = await quotaRequest('increment'); grant = counted.grant;
      if (!grant) throw new Error('unavailable');
      if (!stillAllowed()) {
        // The close/terms change may have happened while quota was consumed.
        // Cancel its unused signed grant without sending any reference image.
        await fetchWithTimeout(AI_PROXY_URL + '/outfit-match/cancel', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ grant })
        }, 20000);
        try { await quotaRequest('refund', grant); } catch { /* No second UI error. */ }
        return;
      }
      status(copy('working'));
      stage = 'generation'; waitLinesFrom = Date.now();
      const promptVariant = promptTurn % 4; promptTurn++;
      const response = await fetchWithTimeout(AI_PROXY_URL + '/outfit-match', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, grant, input: { image_url: photoUrl, ...(detailUrl ? { detail_url: detailUrl } : {}), prompt_variant: promptVariant, ...(jersey() ? { mode: 'jersey' } : {}) } })
      }, PORTRAIT_REQUEST_TIMEOUT_MS);
      const result = await readJsonWithTimeout(response, 60000);
      if (!response.ok) throw makeProxyError(result, response.status);
      if (result.status !== 'succeeded' || !result.output?.[0] || !/^[a-f0-9]{64}$/.test(result.assetId || '')) throw new Error('result');
      received = true;
      // Keep a successful result in memory if temporary preview storage fails.
      // Old proxies return a marked output plus a clean, same-resolution twin.
      // Persist the clean bytes themselves; an in-memory display alias vanishes on reload.
      pendingResult = { data: result.outputClean || result.output[0], assetId: result.assetId, paid: counted.tier === 'pixelback', createdAt: Date.now(), photoUrl, detailUrl };
      stage = 'save';
      // The turbo finish overlaps the preview save, so it adds almost no wait.
      const turbo = watching() ? turboWait() : null;
      await saveResult();
      if (turbo) { await turbo; if (watching()) await finishWait(); }
      if (watching()) apply(pendingResult);
      else { status(copy('ready')); window.RoboPixelJourney?.announce(copy('ready')); }
    } catch (failure) {
      // Diagnostic metadata only: no references, prompts, tokens or provider payloads.
      console.warn('[Outfit Match] failed ' + JSON.stringify({ stage, code: /^[A-Z_]{1,64}$/.test(failure.code || '') ? failure.code : 'CLIENT_ERROR', type: failure.name || 'Error' }));
      if (grant && !received) { try { await quotaRequest('refund', grant); } catch { /* Receipt, if any, remains server-owned. */ } }
      if (failure.message !== 'cancelled' && !(failure.code === 'limit_reached' && freeLimitReached())) error(copy(failure.message === 'security' ? 'security_error' : received ? 'save_error' : failure.code === 'SAFETY_FLAGGED' ? 'safety_error' : 'generate_error'));
    } finally {
      stopWait(); busy = false; controls();
      showQuota();
      if (widget !== null) { window.turnstile?.remove(widget); widget = null; }
      if (!pendingResult) status('');
    }
  }
  async function saveResult() {
    if (!pendingResult || pendingResult.url) return;
    const url = await uploadToS3(pendingResult.data, 'cart-full-images');
    if (!url) throw new Error('save');
    const item = { url, assetId: pendingResult.assetId, paid: !!pendingResult.paid, createdAt: pendingResult.createdAt,
      ...(validReference(pendingResult.photoUrl) ? { photoUrl: pendingResult.photoUrl } : {}),
      ...(validReference(pendingResult.detailUrl) ? { detailUrl: pendingResult.detailUrl } : {}) };
    assets.set(url, item);
    history.push(item); history = history.filter(validResult).slice(-12); persist(); renderHistory();
    pendingResult = item;
    showQuota();
  }
  async function submit() {
    if (busy || reading) return;
    if (pendingResult && !pendingResult.url) {
      busy = true; controls(); error('');
      try { await saveResult(); apply(pendingResult); } catch { error(copy('save_error')); }
      finally { busy = false; controls(); }
      return;
    }
    await create();
  }
  function clear() { history = []; persist(); renderHistory(); }
  function cartProperties(properties) {
    const item = assets.get(selectedDesignUrl);
    if (!item) return;
    if (!validResult(item)) throw new Error(copy('expired'));
    properties['_Design_Tool'] = 'Outfit Match'; properties['_Design_Asset_Id'] = item.assetId;
    if (validReference(item.photoUrl)) properties['_Garment_Image_URL'] = item.photoUrl;
    if (validReference(item.detailUrl)) properties['_Garment_Detail_URL'] = item.detailUrl;
  }
  function init() {
    if (!modal()) return;
    try { const stored = JSON.parse(localStorage.getItem(KEY) || '[]'); if (Array.isArray(stored)) history = stored; } catch { /* Start empty. */ }
    history.filter(validResult).forEach(item => assets.set(item.url, item));
    prune();
    ['photo', 'detail'].forEach(kind => {
      $('[data-outfit-picker="' + kind + '"]').addEventListener('click', () => $('#outfit-' + kind).click());
      $('#outfit-' + kind).addEventListener('change', e => { readPhoto(e.target.files[0], kind); e.target.value = ''; });
    });
    $('[data-outfit-remove-detail]').addEventListener('click', removeDetail);
    $('[data-outfit-submit]').addEventListener('click', submit);
    $('[data-outfit-recheck]')?.addEventListener('click', open);
    modal().addEventListener('click', e => { if (e.target === modal()) close(); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) prune(); });
    setInterval(prune, 5 * 60 * 1000);
  }
  window.OutfitMatch = { open, close, clear, cartProperties, refreshHistoryVisibility,
    refreshQuota: async () => {
      if (!modal()) return null;
      const requestCode = vipCode();
      quota = null; quotaFailed = false; showQuota();
      try { return await quotaRequest('check'); }
      catch (_) { if (requestCode === vipCode()) { quotaFailed = true; quota = null; showQuota(); } return null; }
    },
    remaining: () => quota?.tier === 'pixelback' ? quota.remaining : null };
  if (typeof window.RoboPixelCustomizerReady === 'function') window.RoboPixelCustomizerReady(init);
  else document.addEventListener('robopixel:customizer-ready', init, { once: true });
})();
